;(function(jQuery){

	"use strict";

	function HereDiviMain()
	{
		var global = {
			headerSearchButton: jQuery('.et_pb_menu__search-button'),
			mobileMenu: jQuery('.et_pb_menu__search-button').siblings('.et_mobile_nav_menu'),
		}

		var fn = {
			init: function()
			{
				/**
				 * Call showHeaderSearchButton on mobile menu or search icon click, both of which trigger menu close
				 */
				var mobileMenuToggle = global.mobileMenu.find('.mobile_menu_bar');

				mobileMenuToggle.on('click', fn.showHeaderSearchButton);
				global.headerSearchButton.on('click', fn.showHeaderSearchButton);
			},

			/**
			 * Display mobile header search icon when mobile menu is open (has class 'opened')
			 */
			showHeaderSearchButton: function() {
				var mobileNav = global.mobileMenu.find('.mobile_nav');

				// Pause to make sure mobileNav class has loaded before performing our check
				// Add show-search class to control display with CSS
				setTimeout(function() {
					if (mobileNav.hasClass('opened')) {
						global.headerSearchButton.addClass('show-search');
					} else {
						global.headerSearchButton.removeClass('show-search');
					}
				}, 50);
			}
		}

		jQuery(fn.init);
	}

	new HereDiviMain();
})(jQuery);